module.exports = __webpack_public_path__ + "static/media/logo.5f38e2fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo.png
// module id = 227
// module chunks = 0